<template>
  <div class="b-net-price-table" :class="multicolsClass">   
    <div class="b-net-price-table__header">
      <div
        v-for="h in data.head"
        :key="h.id"
        class="b-net-price-table__header__item"
        :class="[h.colWidth, h.align]">
        {{ h.text }}
      </div>
    </div>
    <div v-for="item in data.data" :key="item.id" class="b-net-price-table__tr">
      <div class="b-net-price-table__year">{{ item.head }}</div>
      <div class="b-net-price-table__data">
        <div
          v-for="(row, i) in item.row"
          :key="i"
          class="b-net-price-table__row">        

          <template v-for="(cell, index) in row.cell" :key="index">
            <div
              class="b-net-price-table__row__item"
              :class="[row.colWidth, row.align]"
              v-html="cell"></div>
          </template>

          <template v-for="(emptyDiv, index) in findEmptyDivs(row.cell)" :key="index">
            <div class="b-net-price-table__row__item col"></div>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import LazyImage from './LazyImage.vue'

export default {
  components: {},
  props: {
    data: {
      default: null,
      type: Object,
    },
  },
  data() {
    return {
      length: 0,
    }
  },
 computed: {
    maxLength() {
      Object.values(this.data.data).forEach((year) => {
        Object.values(year.row).forEach((i) => {
          if (i.cell.length > this.length) {
            this.length = i.cell.length
          }
        })
      })
      console.log('maxLength', this.length)

      return this.length
    },
    multicolsClass(){
      return this.maxLength > 2 ? 'b-net-price-table--multiCols' : ''
    }
  },
  methods: {
    findEmptyDivs(items) {
      return this.maxLength - items.length
    },
  },

  
}
</script>
